import React, { useEffect, useRef, useState, FC, PropsWithChildren } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import cls from 'classnames';

import { useClickOutside } from 'src/explore/hooks/useClickOutside';
import { useEscape } from 'src/explore/hooks/useEscape';
import BreakpointsService from 'src/explore/services/breakpoints';

import { IWebLink } from '../../../../../../../../../../types';
import Button from '../../../../../../atoms/Button';
import Dropdown from './molecules/Dropdown';

import styles from './index.module.sass';

interface MenuProps {
  className?: {
    dropdown?: string;
  };
  links?: IWebLink[];
}

const Menu: FC<PropsWithChildren<MenuProps>> = ({ children, className, links }) => {
  const [ isOpen, setIsOpen ] = useState( false );

  const handleClick = () => {
    setIsOpen(( state ) => !state );
  };

  const ref = useRef( null );
  useClickOutside( ref.current, () => setIsOpen( false ));

  useEscape(() => setIsOpen( false ));

  useEffect(() => {
    const handleScroll = () => {
      if ( BreakpointsService.appliesTo( 'sm' )) {
        setIsOpen( false );
      }
    };
    document.addEventListener( 'scroll', handleScroll );
    return () => {
      document.removeEventListener( 'scroll', handleScroll );
    };
  }, [ setIsOpen ]);

  return (
    <div className={styles.container} ref={ref}>
      <Button className={styles.button} onClick={handleClick}>
        {children}

        <FontAwesomeIcon
          className={cls( styles.icon, { [styles.active]: isOpen })}
          icon={faChevronRight}
        />
      </Button>

      <Dropdown className={className?.dropdown} isExpanded={isOpen} links={links} />
    </div>
  );
};

export default Menu;
